import React from "react";

import classNames from "classnames";

interface Props {
  show: boolean;
  message: string;
  type: string;
}

export const MiniMessageBoxContainer: React.FC<Props> = ({ show, type, message }: Props): JSX.Element => {
  const MiniMessageBoxClasses = classNames("message-box-wrapper mini", type, { show: show });

  return (
    <div className={MiniMessageBoxClasses}>
      <div className="mini-message-content">{message}</div>
    </div>
  );
};
